import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input,Tabs, Button,Collapse,Card,Switch,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';
import JournalEntryView from './JournalEntryView'
import MemberPaymentsEntryView from './MemberPaymentsEntryView'
import { string } from 'prop-types';
import '../tablestyle.css'; // Create this CSS file for custom styles

var converter = require('number-to-words');


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();
const { TabPane } = Tabs;


message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});


var token= ''
var sacco= ''
var username=''
var bizuserid= ''

class ReceiptToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }

  render() {
    return (
      <div style={{padding:20}}>

      {
        this.props.thermalprint===true?
        <div>
        <p>*********************************************************</p>

        <h1 style={{fontWeight:'bolder',display:'flex',alignSelf:'flex-start'}}>  {this.state.companyprofile.sacco_name}</h1>
        <h2 style={{color:'black'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
        {
        this.state.companyprofile.RegisteredPhoneNumber2==""?
        "":","+this.state.companyprofile.RegisteredPhoneNumber2
        }

        </h2>               
        <h2 style={{color:'black'}}>  Email: {this.state.companyprofile.company_email}</h2>
        <h2 style={{color:'black'}}>  Wesite: {this.state.companyprofile.website}</h2>
        <h2 style={{color:'black'}}>  {this.state.companyprofile.box_number}</h2>
        <h2 style={{color:'black'}}>  SLIP/RECEIPT NO: {this.props.journalno}</h2>
        <h2 style={{color:'black'}}>  DATE: {this.props.date}</h2>

        <p>*********************************************************</p>

        <h1 style={{fontWeight:'bolder',display:'flex',alignSelf:'flex-start'}}>  DEPOSIT RECEIPT</h1>

      </div>

        :

          <div>
          <Row> 
          <Col xs="2" sm="2" lg="2">
          <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />

            </Col>
            <Col xs="6" sm="6" lg="6">
            <h2 style={{fontWeight:'bolder'}}>{this.state.companyprofile.sacco_name}</h2>
            <h3 style={{fontWeight:'bolder'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}</h3>               
            <h3 style={{fontWeight:'bolder'}}>Email: {this.state.companyprofile.company_email}</h3>
            <h3 style={{color:'black',fontWeight:'bolder'}}>  DATE: {this.props.date}</h3>

            </Col>
          </Row>
          <h2 style={{fontWeight:'bolder',display:'flex',alignSelf:'center',alignContent:'center',justifyContent:'center'}}>DEPOSIT RECEIPT (CLIENT COPY)</h2>

          </div>
      }


      {
        this.props.thermalprint===true?
        <div>
             <p>********************************</p>

          <h3>
              ACC NUMBER: 
            {this.props.account.AccountNumber}
          </h3>

          <h3>
              ACC NAME :
            {this.props.account.FullName}
          </h3>

          <h3>
              DEPOSITED AMOUNT:
            <CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={','} />
          </h3>

          <h3>
              In Words: 
            ({ this.props.amount_inwords})
          </h3>


          <h3 >
              PAID IN BY: 
            {this.props.paidinby}
          </h3> 

          <h3 >
              CONTACT:
            {this.props.transactorcontact}
          </h3> 

          <h3 >
              TELLER:  
            {username}
          </h3>                 

          <h3 class="force-line-break">
              PAYMENT OF: 
            {this.props.reason}
          </h3> 

          <h3 class="force-line-break">
              TRANSACTION CHANNEL: 
            {this.props.transaction_channel}
          </h3> 

          <p>********************************</p>

          <h4>  Supported by PitechUgLtd ( www.pitech.co.ug )</h4>
        </div>
        :


        <div>
        <reactstrp.Table bordered>
        <thead>
          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}> ACC NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.AccountNumber}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>ACC NAME</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.FullName}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>DEPOSITED AMOUNT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}><CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={true} /></th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>IN WORDS  </th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>({ this.props.amount_inwords})</th>
          </tr>


          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAID IN BY</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.paidinby}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>SLIP NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.journalno}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>CONTACT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transactorcontact}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TELLER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{username}</th>
          </tr>                 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAYMENT OF</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.reason}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TRANSACTION CHANNEL</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transaction_channel}</th>
          </tr> 

        </thead>
          </reactstrp.Table> 


            {
              this.props.print_office_copy?
              <div>
               <Divider style={{ borderStyle: 'dotted' }} />

                <Row> 
                    <Col xs="2" sm="2" lg="2">
                      <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />

                      </Col>
                      <Col xs="6" sm="6" lg="6">
                      <h2 style={{fontWeight:'bolder'}}>{this.state.companyprofile.sacco_name}</h2>
                      <h3 style={{fontWeight:'bolder'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                    
                      </h3>               
                      <h3 style={{fontWeight:'bolder'}}>Email: {this.state.companyprofile.company_email}</h3>
                      <h3 style={{color:'black',fontWeight:'bolder'}}>  DATE: {this.props.date}</h3>

                      </Col>
                    </Row>
                    <h2 style={{fontWeight:'bolder',display:'flex',alignSelf:'center',alignContent:'center',justifyContent:'center',color:'black'}}>DEPOSIT RECEIPT (OFFICE COPY)</h2>

                    <reactstrp.Table bordered>
        <thead>
          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}> ACC NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.AccountNumber}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>ACC NAME</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.FullName}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>DEPOSITED AMOUNT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}><CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={true} /></th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>IN WORDS  </th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>({ this.props.amount_inwords})</th>
          </tr>


          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAID IN BY</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.paidinby}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>SLIP NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.journalno}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>CONTACT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transactorcontact}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TELLER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{username}</th>
          </tr>                 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAYMENT OF</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.reason}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TRANSACTION CHANNEL</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transaction_channel}</th>
          </tr> 

        </thead>
          </reactstrp.Table> 
             </div>
              :
              null

            }


        </div>
    }
        
  </div>
    );
  }
}






class AccountDepositView extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    selectedaccount:'',
    selectedaccountobject:{},
    members:[],
    datarequested:true,
    totalamount:0,
    paidinby:'',
    transactorcontact:'',
    datasubmittedsuccessfully:false,
    savingsamount:0,
    shares_no:0,
    welfareamount:0,
    emergencyamount:0,
    dreamamount:0,
    legacyamount:0,
    childrenamount:0,
    universityamount:0,
    companyprofile:{},
    accountchange:false,
    userprofile:{},
    manualreceipt:'',
    membertype_object:{},

    companyaccounts: [],
    debitaccount:'',
    availableloans:[],
    selectedloan:'',
    selectedloan_obj:{},

    loan_amount:0,
    principleamount:0,
    interestamount:0,
    loanfine_amount:0,

    finaldebit_account:'',
    transaction_details:'',
    previous_loanbalance:0,
    previous_loan_arreas:{},
    thermalprint:false,
    journalno:0,
    change_receiving_account:false,
    default_debit:0,
    companyaccounts_new:[],
    quering_loanbalances:false,
    mini_statement:[],
    extra_deposit_list:[],
    current_extra_field:'',
    print_office_copy:false,
    transaction_channel:''


  }

  callback(key) {
    console.log(key);
  }


   //check empty objecty
 isEmptyObject=(obj)=>{
  for ( var name in obj ) {
    return false;
  }
  return true;
}

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data1 = new FormData();
    form_data1.append('userid', bizuserid);
    
    //get the user profile here
    axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data1,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          userprofile:res.data
        })
     
    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

        this.setState({default_debit:res.data.defaultaccount_for_officecollection_debiting})

        if (this.state.companyprofile.defaultaccount_for_officecollection_debiting!=null || this.state.companyprofile.defaultaccount_for_officecollection_debiting!=0){

          this.setState({finaldebit_account:this.state.companyprofile.defaultaccount_for_officecollection_debiting})

        }


        //set extra deposits
        this.setState({extra_deposit_list:res.data.extra_deposit_list===undefined || res.data.extra_deposit_list===null?[]:JSON.parse(res.data.extra_deposit_list) })


    })

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/user_saccoaccounts/?user=${bizuserid}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })
        this.setState({datarequested:false})
    })

    //all company acocunts

    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          companyaccounts_new:res.data
        })

    })



  }

  

  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
   onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }

  //handle client change
  handleselectedaccountChange= (e) =>{
    this.setState({accountchange:true})
    this.setState({ selectedaccount: e});
    //make query for last transactions
    axios.get(`${serverconfig.backendserverurl}/api/members_dataview/${e}`)
      .then(res => {  
          this.setState({selectedaccountobject: res.data})

          axios.get(`${serverconfig.backendserverurl}/api/membertypes/${res.data.memberType}`)
          .then(res => {  
              this.setState({membertype_object: res.data})
          })

      })


    //GET ALL ISSUED LOANS
      axios.get(`${serverconfig.backendserverurl}/customqueries/get_memberactive_loans/${e}`)
      .then(res => {  
          console.log(JSON.parse(res.data.report))

          this.setState({availableloans: JSON.parse(res.data.report) })

          this.setState({accountchange:false});

      })

      //get ministatement
      axios.get(`${serverconfig.backendserverurl}/api/transactions/?transaction_account=${e}`)
      .then(res => {  
          this.setState({mini_statement: res.data.slice(-4)})

          this.setState({accountchange:false});

      })


  }

  handlepaidinbyChange= (e) => this.setState({ paidinby: e.target.value});
  handletransactorcontactChange= (e) => this.setState({ transactorcontact: e});

  handlesavingsamountChange= (e) => this.setState({ savingsamount: e});

  //sum up all the 
  calculateTotalDeposit=()=>{
    var total=this.state.savingsamount+this.calculateTotalShares()+Number(this.state.principleamount)+Number(this.state.interestamount)+Number(this.state.loanfine_amount)
    

    //loop thrg list of list pyment
    this.state.extra_deposit_list.map((item)=>{
      if (Number(item.amount_paid)>0){
        total+=Number(item.amount_paid)

      }
    })


    return total;
  }

  calculateTotalShares=()=>{
    var total=Number(this.state.shares_no)*Number(this.state.companyprofile.sharevalue)
    return total;
  }

  //calculater total onloan
  calculateTotalonLoan=()=>{
    var tot=0
    tot =Number(this.state.principleamount)+Number(this.state.interestamount)+Number(this.state.loanfine_amount)
    return tot;
  }


  //submit the deposit now
  handleFormSubmit=(event) =>{


    if(Number(this.state.savingsamount)<Number(this.state.selectedaccountobject.minimum_account_deposit) ){
      message.error("Minimum savings deposit is: "+this.state.selectedaccountobject.minimum_account_deposit)
    }else if (this.state.finaldebit_account===""){
      message.info("No selected debit account")}
    
    else{

      //get the transaction channel here
      axios.get(serverconfig.backendserverurl+`/api/companyaccounts/${this.state.finaldebit_account}`)
      .then(res => {
        this.setState({transaction_channel:res.data.account_name})
        
      })




      this.setState({datarequested:true})
      console.log(username)


      let form_data = new FormData();
      form_data.append('date',this.state.date);
      form_data.append('paidinby', this.state.paidinby);
      form_data.append('paidamount', this.calculateTotalDeposit());

      form_data.append('savingsamount', this.state.savingsamount);
      form_data.append('sharesamount', this.calculateTotalShares());
      form_data.append('shares_no', this.state.shares_no);

      form_data.append('transactorcontact', this.state.transactorcontact);
      form_data.append('sacco', sacco);
      form_data.append('account', this.state.selectedaccountobject.id);
      form_data.append('username', username);
      form_data.append('userid', bizuserid);
      form_data.append('manualreceipt', this.state.manualreceipt);

      form_data.append('debitaccount', this.state.finaldebit_account);
      form_data.append('journaltotal', this.calculateTotalDeposit());
      form_data.append('loan_amount', this.calculateTotalonLoan());

      form_data.append('principleamount', Number(this.state.principleamount));
      form_data.append('interestamount', Number(this.state.interestamount));
      form_data.append('loanfine_amount', Number(this.state.loanfine_amount));
      form_data.append('selectedloan', this.state.selectedloan);
      form_data.append('transaction_details', this.generate_reason());
      form_data.append('extra_deposit_list', JSON.stringify(this.state.extra_deposit_list) );


      axios.post(serverconfig.backendserverurl+'/customqueries/createaccountdeposit', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)
        this.setState({journalno:res.data.journalno})

        if (res.data.message==="success"){
          this.setState({datasubmittedsuccessfully:true})
        }
        
      })
      .catch(error => console.log(error))
    }
    
  }



  //generate reason
  generate_reason=()=>{
    var reason=''
    if (this.state.savingsamount>0){
      reason+="SAVINGS ( "+String(this.state.savingsamount)+" ) ,"
    }

    if (this.calculateTotalShares()>0){
      reason+="SHARES ( "+String(this.calculateTotalShares())+" ) ,"
    }

  
    if (this.state.principleamount>0 || this.state.interestamount>0){
      reason+="LOAN ( "+String(Number(this.state.principleamount)+Number(this.state.interestamount))+" ) ,"
    }


    //loop thrg list of list pyment
    this.state.extra_deposit_list.map((item)=>{
      if (Number(item.amount_paid)>0){
        reason+=" "+String(item.account_tocredit)+" ( "+String(item.amount_paid)+" ) ,"

      }else{
        reason+=''
      }
    })

    return reason
  }




  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {


    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
              <div className="content">
                <h3>Pisacco</h3>
              </div>
               </Spin> 
           </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <ReceiptToPrint
            account={this.state.selectedaccountobject} 
            totalamount={this.calculateTotalDeposit()} 
            amount_inwords={converter.toWords(this.calculateTotalDeposit())}
            thermalprint={this.state.thermalprint}

            paidinby={this.state.paidinby} 
            transactorcontact={this.state.transactorcontact}
            date={this.state.date}
            reason={this.generate_reason()}
            journalno={this.state.journalno}
            extra_deposit_list={this.state.extra_deposit_list}
            print_office_copy={this.state.print_office_copy}
            transaction_channel={this.state.transaction_channel}

            ref={el => (this.componentRef = el)} 
            /> 
            </div>

                    <Card>
                    <Result
                    status="success"
                    title="Successfully Deposited "
                    subTitle="Please print receipt or finish off transaction"
                    extra={[
                      <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignSelf:'center'}}>
                      <FormItem >
                      <Switch
                        checked={this.state.thermalprint}
                        onChange={val=>{this.setState({thermalprint:val})}}
                        checkedChildren="Thermal print"
                        unCheckedChildren="A4 print (Click to change to thermal printer)"
                        />
                      </FormItem>
                      &nbsp; &nbsp;

                      {
                        this.state.thermalprint===false?
                        <FormItem >
                        <Switch
                          checked={this.state.print_office_copy}
                          onChange={val=>{this.setState({print_office_copy:val})}}
                          checkedChildren="Client and office copy"
                          unCheckedChildren="Client copy only (click for office copy)"
                          />
                        </FormItem>
                        :
                        null

                      }


                      </div>


                      ,
                      <a>
                      <ReactToPrint
                        trigger={() =>                     
                          <div style={{}}>
                            <Tooltip title="Click to print" placement="top">
                            <p ><PrinterOutlined style={{ fontSize: '40px', color: '#08c' }}/></p>
                            <h6 >Print Receipt</h6>
                            </Tooltip>
                          </div>                          
                            }
                            content={() => this.componentRef}
                          />  
                          </a>,
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                    ]}
                    />

                    </Card>

          </div>

        )

      }else{
        return(
          <div>
            <div>
            <Tabs defaultActiveKey="1" onChange={()=>{}}>

              <TabPane tab="Member deposit form" key="1">
  
              <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                   
                    <h4 style={{fontStyle:'oblique',fontWeight:'bolder'}}>Account To Deposit to</h4>
                    <FormItem label="Account">
                        <Select 
                        placeholder="Account No | Name" 
                        style={{  }} 
                        value={this.state.selectedaccount}
                        onChange={this.handleselectedaccountChange} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                                             
                        >
                          {this.state.members.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                            ))}
                        </Select>
                    </FormItem>
                    {
                      this.state.accountchange?
                      <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
                      <Spin indicator={antIcon} />
                      </div>
                      :
                      null
                    }



                    <h3 style={{fontWeight:'bold',alignSelf:'center',color:'#154360'}}>DEPOSIT FORM</h3>
                    <Form
                      onFinish={(event) => this.handleFormSubmit(event)}
                  >

                 {
                    this.state.companyprofile.automated_transaction_date===false?
                    <FormItem label="Date"
                      name='date'
                      rules={[
                        {
                          required: true,
                          message: 'Please Select date',
                        },
                      ]}
                    >
                        <DatePicker value={moment()} onChange={(date, dateString)=>{this.setState({ date: dateString})}} format={dateFormat} />
                    </FormItem>
                  :
                  null
                  }


                    <FormItem label={<h6 style={{fontWeight:'bold'}}>Savings Amount </h6>}
                    name="savingsamount"
                    rules={[
                      {
                        required: false,
                        message: 'Please input amount',
                      },
                    ]}
                    
                    >
                      <InputNumber
                        style={{ width: 200 }} 
                        defaultValue={0.0}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\x\s?|(,*)/g, '')}
                        onChange={this.handlesavingsamountChange}
                      />    
                                  
                    </FormItem>

                    
                    

                    {
                      this.state.companyprofile.sharesfeature?
                      <FormItem label={<h6 style={{fontWeight:'bold'}}>Shares no </h6>}
                      name="shares_no"
                      rules={[
                        {
                          required: false,
                          message: 'Please input amount',
                        },
                      ]}
                      >
  
                        <div style={{display:'flex',flexDirection:'column'}}>
                          <p style={{color:'#154360'}}>Share Value: {this.state.companyprofile.sharevalue} || Total Share amount: {this.calculateTotalShares()}</p>
  
                          <Input name="shares_no"   
                          placeholder="0.0" 
                          value={this.state.shares_no} 
                          onChange={(e) => this.setState({ shares_no: e.target.value})}/>
   
                        </div>
         
                      </FormItem>
                      :
                      null
                    }
                    



                    {
                    this.state.availableloans.length>0?
                    <FormItem label="Select Loan to Repay."
                        name="selectedloan"
                        rules={[
                          {
                            required: false,
                            message: 'Please select loan',
                          },
                        ]}                  
                    >
                        <Select 
                        placeholder="Select Loan to Repay" 
                        style={{  }} 
                        value={this.state.selectedloan}
                        onChange={(val)=>{
                          this.setState({quering_loanbalances:true})
                          this.setState({selectedloan:val})

                          axios.get(`${serverconfig.backendserverurl}/api/loanissues/${val}`)
                          .then(res => {  
                              this.setState({selectedloan_obj: res.data})
                          })


                          //query the latest balance
                          var form_data1 = new FormData();
                          form_data1.append('loan_id', val);

                          ///make a post request now
                            axios.post(serverconfig.backendserverurl+'/customqueries/queryfor_loanbalance', form_data1, {
                              headers: {
                                'content-type': 'multipart/form-data'
                              }
                            })
                          .then(res => {
                            this.setState({previous_loanbalance:Number(res.data.runningint_bal)+Number(res.data.running_principle)+Number(res.data.runningfine_balance)})

                            this.setState({previous_loan_arreas:res.data})
                            this.setState({quering_loanbalances:false})

                          })
                          .catch(error => console.log(error))

                        }} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                                              
                        >
                          {this.state.availableloans.map(
                            (loan)=>(
                              <Option value={loan.id}>Amount {loan.approved_amount} | Date {loan.date} | Months {loan.loan_period} | NO {loan.loan_number}</Option>
                            ))}
                        </Select>
                      </FormItem>
                    :
                    null
                  }


                  {
                  this.state.availableloans.length>0 && this.isEmptyObject(this.state.selectedloan_obj)===false && this.isEmptyObject(this.state.previous_loan_arreas)===false?
                  <h5>
                    Principle arrears : <CurrencyFormat value={this.state.previous_loan_arreas.running_principle.toFixed(2)} displayType={'text'} thousandSeparator={true}/> ,
                    Interest arrears : <CurrencyFormat value={this.state.previous_loan_arreas.runningint_bal.toFixed(2)} displayType={'text'} thousandSeparator={true}/> ,
                    Fine arrears : <CurrencyFormat value={this.state.previous_loan_arreas.runningfine_balance.toFixed(2)} displayType={'text'} thousandSeparator={true}/> ,

                    Total arrears: <CurrencyFormat value={this.state.previous_loanbalance.toFixed(2)} displayType={'text'} thousandSeparator={true}/>
                    
                  </h5>
                  :
                  <div>
                    {
                      this.state.quering_loanbalances?
                      <h4 style={{color:'green'}}>...  Quering loan balances  ...</h4>
                      :
                      null
                    }
                  </div>
                  
                  }

                  {
                    this.state.availableloans.length>0 && this.isEmptyObject(this.state.selectedloan_obj)===false?
                    <FormItem label={<h6 style={{fontWeight:'bold'}}>Loan Principle </h6>}
                    >
                        <Input name="principleamount"   placeholder="0.0" value={this.state.principleamount} onChange={(e) => this.setState({ principleamount: e.target.value})}/>
                    </FormItem>
                    :
                    null 
                  }
                  

                {
                    this.state.availableloans.length>0 && this.isEmptyObject(this.state.selectedloan_obj)===false?
                    <FormItem label={<h6 style={{fontWeight:'bold'}}>Loan Interest </h6>}
                    >
                        <Input name="interestamount"   placeholder="0.0" value={this.state.interestamount} onChange={(e) => this.setState({ interestamount: e.target.value})}/>
                    </FormItem>
                    :
                    null
                  }


                  {
                    this.state.availableloans.length>0 && this.isEmptyObject(this.state.selectedloan_obj)===false?
                    <FormItem label={<h6 style={{fontWeight:'bold'}}>Loan fine amount </h6>}
                    >
                        <Input name="loanfine_amount"   placeholder="0.0" value={this.state.loanfine_amount} onChange={(e) => this.setState({ loanfine_amount: e.target.value})}/>
                    </FormItem>
                    :
                    null
                  }



                   {
                    this.state.extra_deposit_list.length>0?
                    <div>
                      {
                        this.state.extra_deposit_list.map((item)=>{

                          if(item.member_type===this.state.membertype_object.type_name){
   
                            return (
                              <FormItem  label={<h6 style={{fontWeight:'bold'}}>{item.account_tocredit}|Minimum {item.minimum_amount}  </h6>} >
                                  <Input  
                                   type='number' 
                                   placeholder="0.0"                             
                                     onChange={(e) =>{
                                      var itemKey=item.key
                                      var value=e.target.value
  
                                      const index = this.state.extra_deposit_list.findIndex(item => item.key === itemKey);
  
                                      if (value<Number(item.minimum_amount)){
                                        message.error("Amount cant be less than "+String(item.minimum_amount))
  
                                        if (index !== -1) {
                                          // Create a new object with the updated quantity
                                          const updatedItem = {
                                            ...this.state.extra_deposit_list[index],
                                            "amount_paid": 0,
                                          };
                        
                                          // Replace the item at the found index with the updated object
                                          const updatedShoppingList = [...this.state.extra_deposit_list];
                                          updatedShoppingList[index] = updatedItem;
                        
                                          // Update the state with the new shopping list
                                          this.setState({extra_deposit_list:updatedShoppingList});
                        
                                        }


                                      }else{
                                        if (index !== -1) {
                                          // Create a new object with the updated quantity
                                          const updatedItem = {
                                            ...this.state.extra_deposit_list[index],
                                            "amount_paid": value,
                                          };
                        
                                          // Replace the item at the found index with the updated object
                                          const updatedShoppingList = [...this.state.extra_deposit_list];
                                          updatedShoppingList[index] = updatedItem;
                        
                                          // Update the state with the new shopping list
                                          this.setState({extra_deposit_list:updatedShoppingList});
                        
                                        }
  
                                      }  
    
                                  } }/>
                              </FormItem>
  
                            )
  
                            
                          }



                        })
                      }


                    </div>
                    :
                    null
                   } 



                    <FormItem label={<h4 style={{fontWeight:'bold',color:'#154360'}}>Total Amount </h4>}
                    >
                      <h3 style={{fontWeight:'bolder'}}><CurrencyFormat  value={this.calculateTotalDeposit()} displayType={'text'} thousandSeparator={true} /></h3>
                   
                    </FormItem>
  
                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Paid In By:</h4>}
                    name="paidinby"
                    rules={[
                      {
                        required: true,
                        message: 'Please input name',
                      },
                    ]}
                    
                    >
                      <Input name="paidinby"  placeholder="Name" value={this.state.paidinby} onChange={this.handlepaidinbyChange}/>
     
                    </FormItem>
  
                    <FormItem 
                      label={<h4 style={{fontWeight:'bold'}}>Transactor Contact:</h4>}
                      >
                    <PhoneInput
                      countrySelectProps={{ unicodeFlags: true }}
                      defaultCountry="UG"
                      placeholder="Enter phone"
                      value={this.state.transactorcontact}
                      onChange={this.handletransactorcontactChange}
                      />
                  </FormItem> 



                  <FormItem label={<h4 style={{fontWeight:'bold'}}>Manual Receipt NUmber:</h4>}                    
                    >
                      <Input name="manualreceiptnumber" type='number' placeholder="0" value={this.state.manualreceipt} onChange={(val)=>{this.setState({manualreceipt:val.target.value})}}/>
                  </FormItem>

{  /*                <FormItem 
                      label={<h4 style={{fontWeight:'bold'}}>Transaction details.</h4>}
                      name="Transaction"
                      rules={[
                        {
                          required: true,
                          message: 'Please input details',
                        },
                      ]}
                      >
                   <TextArea
                      placeholder="Transaction Details"
                      autoSize={{ minRows: 2, maxRows: 8 }}
                      value={this.state.transaction_details}
                      onChange={(val)=>{this.setState({transaction_details:val.target.value})}}
                    />
                
                  </FormItem> */}

                    <br></br>

                  {
                     this.state.companyprofile.defaultaccount_for_officecollection_debiting!=0?
                   
                   <div>

                  <FormItem 
                    label={<h4 style={{fontWeight:'bold'}}>Auto Debit A/C {this.state.companyprofile.defaultaccount_for_officecollection_debiting}</h4>}
                    >

                      <Select 
                        placeholder="Account" 
                        style={{  }} 
                        value={this.state.default_debit}
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}                    
                        >
                          {this.state.companyaccounts_new.map(
                            (accnt)=>{

                              if (this.state.default_debit===accnt.id){
                                return (
                                  <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                                );
                              }

                            }
                            
                            )}
                        </Select>

                    </FormItem>


                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Change Account</h4>} >
                    <Switch
                      checked={this.state.change_receiving_account}
                      onChange={val=>{this.setState({change_receiving_account:val})}}
                      checkedChildren="Changed to manual"
                      unCheckedChildren="Click to change"
                      />

                    </FormItem>

                    {
                    this.state.change_receiving_account?
                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Receiving A/C (Debit A/C).</h4>}
                    name="debitaccount"
                    rules={[
                      {
                        required: true,
                        message: 'Please select account',
                      },
                    ]}
                  >
                        <Select 
                        placeholder="Account" 
                        style={{  }} 
                        value={this.state.debitaccount}
                        onChange={(val)=>{
                          
                          this.setState({debitaccount:val})
                        
                          //get final debit account
                          axios.get(`${serverconfig.backendserverurl}/api/user_saccoaccounts/${val}`)
                          .then(res => {  
                              this.setState({
                                  finaldebit_account: res.data.company_account
                              })

                              console.log("deb acbt: "+res.data.company_account)
                                
                          })
                        
                        }} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}                    
                        >
                          {this.state.companyaccounts.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                            ))}
                        </Select>
                    </FormItem>
                    :
                    null
                  }   


                   </div>
                   
                   
                    :
                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Receiving A/C (Debit A/C).</h4>}
                    name="debitaccount"
                    rules={[
                      {
                        required: true,
                        message: 'Please select account',
                      },
                    ]}
                  >
                        <Select 
                        placeholder="Account" 
                        style={{  }} 
                        value={this.state.debitaccount}
                        onChange={(val)=>{
                          
                          this.setState({debitaccount:val})
                        
                          //get final debit account
                          axios.get(`${serverconfig.backendserverurl}/api/user_saccoaccounts/${val}`)
                          .then(res => {  
                              this.setState({
                                  finaldebit_account: res.data.company_account
                              })

                              console.log("deb acbt: "+res.data.company_account)
                                
                          })
                        
                        }} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}                    
                        >
                          {this.state.companyaccounts.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                            ))}
                        </Select>
                    </FormItem>


                  }   


               

                  <FormItem>
                    <Button  type="primary" htmlType="submit">Submit</Button>
                  </FormItem>
                  </Form>
                  </Card>
                   
                  </Col>
  
                 <Col xs="12" sm="6" lg="6">
                   <Card>
                   <h3 style={{fontWeight:'bold',color:'#154360'}}>Account Details</h3>
                    <h4>Account Number:{this.state.selectedaccountobject.AccountNumber}</h4>
                    <h4>Account Contact:{this.state.selectedaccountobject.RegisteredPhoneNumber1}</h4>
                    <h4>Account Name:{this.state.selectedaccountobject.FullName}</h4>
                    <h4>Savings Balance:<CurrencyFormat value={this.state.selectedaccountobject.savings_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Savings interest balance:<CurrencyFormat value={this.state.selectedaccountobject.saving_interestbalance} displayType={'text'} thousandSeparator={true}  /> </h4>

                    <h4>Sharesamount balance:<CurrencyFormat value={this.state.selectedaccountobject.sharesamount_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Shares number balance:{this.state.selectedaccountobject.sharesnumber_balance}</h4>
                    <h4>Loan balance:<CurrencyFormat value={this.state.selectedaccountobject.loan_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Loan interest:<CurrencyFormat value={this.state.selectedaccountobject.loaninterest_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Loan fine:<CurrencyFormat value={this.state.selectedaccountobject.loanfine_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Fixed deposit:<CurrencyFormat value={this.state.selectedaccountobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Savings loan security:<CurrencyFormat value={this.state.selectedaccountobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}  /> </h4>

                    <h2>Deposit details: {this.generate_reason()}</h2>

                    {
                      this.state.mini_statement.length>0?
                      <div style={{overflowX:'auto'}}>
                        <h3  style={{fontWeight:'bold',color:'#154360'}}>Member Ministatement</h3>

                        <reactstrp.Table bordered>
                                <thead>
                                  <tr>
                                  <th>Date</th>
                                  <th>Subaccount</th>
                                  <th>Debit</th>
                                  <th>Credit</th>
                                  <th>Desc</th>
  
                                  </tr>
                                </thead>
                                <tbody>
                                {this.state.mini_statement.map(
                                  (item)=>(
                                    <tr>
                                    <td>{item.date}</td>
                                    <td>{item.subaccount}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td>{item.transaction_details}</td>
                                    </tr>
                                  ))}
                             
                              </tbody>
                          </reactstrp.Table>

                      </div>
                      :
                      null
                    }


                   </Card>

                </Col>
            </Row>


            </TabPane>

            <TabPane tab="Multi journal entries form" key="2">
            <JournalEntryView />

             </TabPane>

             <TabPane tab="Member payment form" key="3">
              <MemberPaymentsEntryView/>

              </TabPane>

          </Tabs>
  
         </div>
  
       </div>              
                      
        )
      }

    }
   
  }
}

export default AccountDepositView; 
